import { ILinkWidgetGeneratorType } from "./../../../shared/interfaces/ILinkWidgetGeneratorType";
import { DashboardQuickLinkModel } from "../../../shared/models/DashboardQuickLinkModel";
import { Pages } from "@constants/pages/Pages";
import { ApplicationPermissionsModel } from "@models/permissions/ApplicationPermissionsModel";

export class InsightsLinkGenerator implements ILinkWidgetGeneratorType {
    getTypes(permissions: ApplicationPermissionsModel, pages: Pages): DashboardQuickLinkModel[] {
        const quickLinks = [];
        if (permissions.HasReportingAccess) {
            quickLinks.push({
                title: "linkWidget.reportingTitle",
                icon: "fad fa-file-invoice",
                page: pages.Reports,

                description: "linkWidget.reportingDescription",
            });
        }

        if (permissions.HasExportAccess) {
            quickLinks.push({
                title: "linkWidget.exportsTitle",
                icon: "fad fa-cloud-download",
                page: pages.Exports,

                description: "linkWidget.exportsDescription",
            });
        }

        if (permissions.Documents.SharedViewer) {
            quickLinks.push({
                title: "linkWidget.sharedDocumentsTitle",
                icon: "fad fa-folders",
                page: pages.SharedDocuments,

                description: "linkWidget.sharedDocumentsDescription",
            });
        }

        if (permissions.IsApplicationAdmin) {
            quickLinks.push({
                title: "linkWidget.thirdPartyAssuranceTitle",
                icon: "fad fa-calculator",
                page: pages.TpaRequests,

                description: "linkWidget.thirdPartyAssuranceDescription",
            });
        }

        return quickLinks;
    }
}
